import styled from 'styled-components';

/** 검색 사전 화면 공통 — 토큰 칩 · 경고 · 미리보기 · 저장 결과 */
export const SearchDictionaryStyle = styled.div`
  /* 간격은 결제 설정 화면이 쓰는 4·8·12·16·24 단계만 쓴다 */
  .term-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
  }
  .term-tags .ant-tag {
    margin-inline-end: 0;
    padding-inline: 8px;
    font-size: 13px;
    line-height: 22px;
  }
  .term-tags-row {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
  }
  .field-stack {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
  .rule-feedback {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  .rule-feedback .ant-alert {
    font-size: 13px;
  }
  .related-rules {
    display: inline-flex;
    flex-wrap: wrap;
    gap: 4px;
    margin-left: 6px;
  }
  .preview-box,
  .save-result {
    padding: 16px;
    border: 1px solid #edf0f4;
    background: #fafbfc;
    border-radius: 4px;
  }
  .preview-row {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
    margin-top: 12px;
    font-size: 13px;
  }
  .preview-row:first-child {
    margin-top: 0;
  }
  .preview-row > .preview-label {
    color: #626e7f;
    min-width: 88px;
  }
  .preview-row .ant-tag {
    margin-inline-end: 0;
    font-size: 13px;
    line-height: 22px;
  }

  /* 규칙 상세 · 등록 — 탭 화면과 같은 흰 카드. 저장 줄이 sticky 라 overflow 는 두지 않는다 */
  &.rule-card {
    background: #fff;
    border: 1px solid #e4e8ef;
    border-radius: 4px;
  }
  .rule-card-body {
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding: 24px;
  }
  .rule-head {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 12px;
  }
  .rule-head h2 {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
  }
  .rule-head .ant-tag {
    margin-inline-end: 0;
  }
  .rule-head-back {
    height: auto;
    padding: 4px 0;
  }
  .rule-head-divider {
    width: 1px;
    height: 16px;
    background: #dfe3ea;
  }
  .rule-id-chip {
    padding: 3px 8px;
    background: #f4f5f7;
    border-radius: 4px;
  }
  .rule-column {
    display: flex;
    flex-direction: column;
    gap: 24px;
    min-width: 0;
  }
  .overlap-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin: 0;
    padding: 0;
    list-style: none;
  }
  .overlap-list > li {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
  }

  /* 동의어 목록 — 칩을 키운 만큼 행 위아래를 줄여 한 화면에 더 보이게 */
  .synonym-table .ant-table-tbody > tr > td {
    padding-top: 10px;
    padding-bottom: 10px;
  }
  /* 자리를 차지하지 않게 칸 오른쪽에 겹쳐 띄운다 — 토큰이 많은 줄이 힌트 때문에 한 줄 더 내려가지 않게 */
  .synonym-table .ant-table-tbody > tr > td.token-cell {
    position: relative;
  }
  .row-open-hint {
    position: absolute;
    top: 50%;
    right: 16px;
    transform: translateY(-50%);
    font-size: 12px;
    color: #7950f2;
    white-space: nowrap;
    /* 토큰이 칸 끝까지 찬 줄에서 겹쳐도 읽히게 — 표 hover 배경과 같은 색 */
    padding-left: 8px;
    background: #fafafa;
    opacity: 0;
    pointer-events: none;
  }
  .synonym-table .ant-table-tbody > tr:hover .row-open-hint,
  .row-open-hint:focus-visible {
    opacity: 1;
    pointer-events: auto;
  }
  .row-open-hint:focus-visible {
    outline: 2px solid #b197fc;
    outline-offset: 2px;
    border-radius: 2px;
  }

  /* 빠른 편집 모달 — 모달은 화면 밖(portal)에 열려 작업 화면 스타일을 못 받는다. 모달 안에서만 다시 둔다 */
  &.quick-edit-body {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  &.quick-edit-body .settings-muted {
    color: #626e7f;
    font-size: 13px;
  }
  &.quick-edit-body .settings-label {
    font-size: 13px;
    font-weight: 600;
  }
  &.quick-edit-body .settings-label .settings-muted {
    font-weight: 400;
  }
  .block-title {
    display: flex;
    align-items: baseline;
    gap: 8px;
    margin-bottom: 8px;
  }
  .block-title h3 {
    margin: 0;
    font-size: 13px;
    font-weight: 600;
  }
  .spread-note {
    color: #ad4e00;
    font-weight: 600;
  }
  .count-before {
    background: #f5f5f5;
    color: #707070;
    text-decoration: line-through;
    padding: 1px 6px;
  }
  .count-after {
    background: #e6f4ff;
    color: #0958d9;
    font-weight: 700;
    padding: 1px 6px;
  }
  .diff-added {
    color: #237804;
    font-weight: 600;
  }
  .diff-removed {
    color: #a8071a;
    text-decoration: line-through;
  }
  .rule-id {
    font-family: 'SF Mono', Consolas, monospace;
    font-size: 12px;
    color: #626e7f;
  }
`;
